const colors = {
  dodgerBlue: '#2278CE',

  greenLeaf: '#4d8210',
  HSBC_red: '#DB0011',
  black: '#000000',
  white: '#ffffff',
  lightPearl: '#F3F3F3',
  pearl: '#EDEDED',
  silver: '#D7D8D6',
  pewter: '#767676',
  charcoal: '#333333',

  redError: '#A8000B',
  amberWarning: '#FFBB33',
  green: '#00847F',
  blue: '#305A85',
  redTint: '#F9F2F3',
  amberTint: '#FFF8EA',
  greenTint: '#E5F2F2',
  blueTint: '#EBEFF4',
  duskPearl: '#6D8EA6',
  jade: '#14A5AB',
  emerald: '#4FA62F',
  amber: '#E67310',
  ruby: '#D71E8D',
  lolite: '#834EFF',
  sapphire: '#2580DC',
  darkPearl: '#4D6474',
  darkJade: '#008580',
  darkEmerald: '#34880F',
  darkAmber: '#BF610F',
  darkRuby: '#A8166D',
  darkLolite: '#6637D5',
  darkSapphire: '#1564B5',

  fontOnDark: '#333333',
  fontOnLight: '#FFFFFF',
  mariner: '#2278CE',

  roseFrog: '#E5B2B5',
  goldenrod: '#FFCF70',
  sinbad: '#99CECC',
  casper: '#ACBDCE',
  brightRed: '#AF000D',
  redDevil: '#83000A',
  tundora: '#404040',
  slate: '#3E505D',
  catskillWhite: '#EBF5F5',
  swansDown: '#D9EDEC',

  // TODO: add interaction colors.
};

export default colors;
